import { render, staticRenderFns } from "./Touristtax.vue?vue&type=template&id=14502df3&scoped=true&"
import script from "./Touristtax.vue?vue&type=script&lang=js&"
export * from "./Touristtax.vue?vue&type=script&lang=js&"
import style0 from "./Touristtax.vue?vue&type=style&index=0&id=14502df3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14502df3",
  null
  
)

export default component.exports